





import {apiV1AdminStaffBlogPath, apiV1AdminStaffBlogsPath} from '@/rails/routes'
import {Component} from 'vue-property-decorator'
import PostForm from '@/components/admin/PostForm.vue'
import PostNew from '@/components/admin/PostNew'
import {BreadCrumb} from '@/pages/page-base'

@Component({
  components: {
    PostForm
  }
})
export default class StaffBlogNew extends PostNew {
  path = 'staff_blogs'
  createPath = apiV1AdminStaffBlogsPath()

  async mounted(): Promise<void> {
    this.targetPath = apiV1AdminStaffBlogPath('new')
    return super.mounted()
  }

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: 'スタッフブログ一覧',
        to: '/admin/staff_blogs',
        exact: true
      },
      {
        text: 'スタッフブログ新規作成'
      }
    ]
  }
}
